export const mixin = {
  data: () => ({
    fieldProps: {
      color: "#4a31c0",
      outlined: true,
      flat: true,
    },
  }),
};
